module.exports = __webpack_public_path__ + "assets/img/theme-1.d57abaec.png";